import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { Redirect } from "react-router";

import GuestLayout from "src/bepaid/layouts/GuestLayout";
import Flex from "antd-mobile/es/flex";
import Typography from "antd/es/typography";
import Image from "src/bepaid/components/Image";
import Card from "src/bepaid/components/Card";
import HeaderLogo from "src/bepaid/assets/images/ipaymy_logo.svg";
import ROUTES from "src/bepaid/routes";
import ChangePassword from "src/bepaid/layouts/Menu/components/ChangePassword";

import styles from "./ChangePassword.module.scss";

const CheckoutConfirmation: React.FC<any> = props => {
  const hasToken = props.hasToken;

  if (!hasToken) {
    return <Redirect to={ROUTES.ROOT} />;
  }

  const renderContent = () => (
    <div className={styles.wrapper}>
      <Flex justify="center" align="center">
        <Flex.Item span={20} className={styles.centerText}>
          <Typography.Text className={styles.signInText}>
            For security, passwords expire every 90 days. Please update it to
            login.
          </Typography.Text>
        </Flex.Item>
      </Flex>
      <div className={styles.content}>
        <ChangePassword wrapperCustomClassname={styles.changePasswordWrapper} />
      </div>
    </div>
  );

  const renderDesktopView = () => {
    return (
      <div className={styles.desktopWrapper}>
        <Card>{renderContent()}</Card>
      </div>
    );
  };

  return (
    <GuestLayout
      header={<Image src={HeaderLogo} />}
      title={
        <Typography.Text className={styles.title}>
          Change password
        </Typography.Text>
      }
    >
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderContent()}</MobileView>
    </GuestLayout>
  );
};

export default CheckoutConfirmation;
